import { Box, Text, TextField } from "@radix-ui/themes";
import { Control, Controller, FieldErrors } from "react-hook-form";
import { formatDateForInput } from "../../../utils/dateFormatter";
import styles from './DatefieldComponent.module.scss';
interface DateFieldProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: any;
  fieldProps?: any;
  composedName?: { parent: any, prop: any }
  required?: boolean;
}

const DateFieldComponent = ({ name, label, control, errors, style, fieldProps, composedName, required }: DateFieldProps) => {
  const castedErrors = errors as Record<string, any>;

  const composedError = composedName && composedName.parent && composedName.prop
    ? castedErrors?.[composedName.parent]?.[composedName.prop]
    : undefined;

  return <Box {...style} >
    <Text as="label" size="2" className={styles.label}>{<span>{label} {required && <span style={{ color: 'red' }}>*</span>}</span>}</Text>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField.Root
          size="2"
          type="date"
          {...field}
          {...fieldProps}
          value={formatDateForInput(field.value)}
        />
      )}
    />
    {composedError ? (
      <Text color="red" size="1">
        {composedError.message as string}
      </Text>
    ) : (
      errors?.[name] && (
        <Text color="red" size="1">
          {errors?.[name]?.message as string}
        </Text>
      )
    )}

  </Box>
};

export default DateFieldComponent;